import { apiUrl } from "./base";

export type ExtractAnswerResponse = {
  answer?: string;
  paraphrase?: string;
  quote?: string;
  sentenceIndex?: number;
  confidence?: number;
};

export async function extractAnswer(input: {
  question: string;
  transcript: string;
  contactType?: string;
  strict?: boolean;
  sessionId?: string | null;
}): Promise<ExtractAnswerResponse> {
  const res = await fetch(apiUrl("/api/extractAnswer"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });

  if (!res.ok) {
    throw new Error(await res.text());
  }

  return (await res.json()) as ExtractAnswerResponse;
}
